export default __webpack_public_path__ + "static/media/Connector_Type2.22bdc0cd.svg";